import { ComponentProps } from 'react'
import { GetStaticPaths, GetStaticProps } from 'next'
import { getJournalsPageProps } from '~pages/journals-page/get-journals-page-props'
import { JournalsPage } from '~pages/journals-page/journals-main-page'
import { getJournalSlugs } from '~shared/api/single-journal-data/getJournalSlugs'

export default function JournalsByTag(
  props: ComponentProps<typeof JournalsPage>
) {
  return <JournalsPage {...props} />
}

export const getStaticProps: GetStaticProps = async context => {
  const props = await getJournalsPageProps(context)
  const tag = context.params?.tag?.toString()

  if (props.faculties && !props.faculties.some(item => item.slug === tag)) {
    return { notFound: true }
  }

  return { props }
}

export const getStaticPaths: GetStaticPaths = async ({ locales }) => {
  try {
    const journals = await getJournalSlugs(locales)
    const unique = new Set(
      journals.map(({ locale, tag }) => JSON.stringify({ locale, tag }))
    )

    return {
      paths: Array.from(unique, item => {
        const { locale, tag } = JSON.parse(item)
        return { params: { tag }, locale }
      }),
      fallback: 'blocking'
    }
  } catch (err) {
    console.error(err)
    return { paths: [], fallback: 'blocking' }
  }
}
